import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import DirectTokenPurchaseModal from './DirectTokenPurchaseModal';
import FreeTrialLimitModal from './FreeTrialLimitModal';
import freeTrialManager from '../../services/auth/freeTrialManager';

const ProtectedRoute = ({ children }) => {
  const [showTokenModal, setShowTokenModal] = useState(false);
  const [showTrialLimitModal, setShowTrialLimitModal] = useState(false);
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Check if current route is the random test route
  const isRandomTestRoute = location.pathname === '/test-aleatorio';
  
  // All other routes require authentication
  const requiresAuth = !isRandomTestRoute;

  useEffect(() => {
    const checkTrialStatus = async () => {
      if (!isAuthenticated) {
        // For random test route, check if user has available tests
        if (isRandomTestRoute) {
          // Force refresh the status to ensure it's up-to-date
          const status = await freeTrialManager.getUserStatus(true);
          if (status.testsAvailable === 0) {
            setShowTrialLimitModal(true);
          }
        }
        // For other routes, always show trial limit modal if not authenticated
        else if (requiresAuth) {
          setShowTrialLimitModal(true);
        }
      }
    };

    checkTrialStatus();
    
    // Add event listener for page visibility changes to recheck status when tab becomes visible
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkTrialStatus();
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isAuthenticated, isRandomTestRoute, requiresAuth]);

  // If authentication is required and user is not authenticated, show appropriate modals
  if (requiresAuth && !isAuthenticated) {
    return (
      <>
        <DirectTokenPurchaseModal
          isOpen={showTokenModal}
          onClose={() => setShowTokenModal(false)}
        />
        <FreeTrialLimitModal
          isOpen={showTrialLimitModal}
          onClose={() => setShowTrialLimitModal(false)}
        />
        {/* Don't render children for protected routes if not authenticated */}
        {null}
      </>
    );
  }

  // For random test route or authenticated users, render children with modals if needed
  return (
    <>
      <FreeTrialLimitModal
        isOpen={showTrialLimitModal}
        onClose={() => setShowTrialLimitModal(false)}
      />
      {children}
    </>
  );
};

export default ProtectedRoute;